import "../../styles/Cookies.css";
import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FaCookieBite } from "react-icons/fa";

const Cookies = () => {
  useEffect(() => {
    (() => {
      const getCookie = (name) => {
        const value = " " + document.cookie;
        const parts = value.split(" " + name + "=");
        return parts.length < 2 ? undefined : parts.pop().split(";").shift();
      };

      const setCookie = (name, value, expiryDays, domain, path, secure) => {
        const exdate = new Date();
        exdate.setHours(
          exdate.getHours() +
            (typeof expiryDays !== "number" ? 365 : expiryDays) * 24
        );
        document.cookie =
          name +
          "=" +
          value +
          ";expires=" +
          exdate.toUTCString() +
          ";path=" +
          (path || "/") +
          (domain ? ";domain=" + domain : "") +
          (secure ? ";secure" : "");
      };

      const banner = document.querySelector(".cookies-banner");
      const acceptBtn = banner?.querySelector("button");
      const cookieName = "cookiesBanner";
      const hasCookie = getCookie(cookieName);

      if (!hasCookie) {
        banner?.classList.add("show");
      }

      acceptBtn?.addEventListener("click", () => {
        setCookie(cookieName, "closed");
        banner?.classList.remove("show");
        banner?.classList.add("hide");
        setTimeout(() => banner?.remove(), 500);
      });
    })();
  }, []);

  return (
    <div className="cookies-banner">
      <div className="cookies-inner">
        <div className="cookies-icon">
          <FaCookieBite />
        </div>
        <div className="cookies-text">
          We use cookies to personalize your experience and analyze site usage.{" "}
          <NavLink to="/privacypolicy" className="cookies-link text-primary">
            Privacy Policy
          </NavLink>
        </div>
        <button className="cookies-btn bg-primary text-secondary">
          Got it
        </button>
      </div>
    </div>
  );
};

export default Cookies;
